<template>
  <qx-card :noTitle="true">
    <h2 class="title">
      账户余额共（元）：
      <span class="error totalAmount">{{totalAmount}}</span>
    </h2>
    <!-- 找油账户 -->
    <qx-detail-box
      :data="findData"
    >
      <!-- 余额 -->
      <section class="clearPa" slot="zhaoyouCashOilBalance">
        <article class="left error">{{originData.zhaoyouCashOilBalance / 100}}</article>
        <article class="right">
          <span class="primary btn cur" @click="toRecord">账户流水</span>
          <span v-if="checkPermpisions('1000009')" class="primary btn cur" @click="toCostApply">充值</span>
          <span class="primary btn cur" @click="toDetail">账户详情</span>
        </article>
      </section>
      <!-- 余额 end -->
      <!-- 无发票 -->
      <section slot="zhaoyouRebateOilBalance1" class="error">
        {{originData.zhaoyouRebateOilBalance / 100}}
      </section>
      <!-- 无发票 end -->
      <!-- 供应商赠送 -->
      <section slot="zhaoyouRebateOilBalance2" class="error">
        {{originData.zhaoyouRebateOilBalance / 100}}
      </section>
      <!-- 供应商赠送 end -->
      <!-- 有发票 -->
      <section slot="zhaoyouCashOilBalance1" class="error">
        {{originData.zhaoyouCashOilBalance / 100}}
      </section>
      <!-- 有发票 end -->
      <!-- 自己收发票 -->
      <section slot="zhaoyouCashOilBalance2" class="error">
        {{originData.zhaoyouCashOilBalance / 100}}
      </section>
      <!-- 自己收发票 end -->
    </qx-detail-box>
    <!-- 找油账户 end -->
    <!-- 本车队定点油 -->
    <qx-detail-box
      :data="siteData"
    >
      <!-- 可用授信 -->
      <section class="clearPa" slot="creditLine1">
        <article class="left error">{{originData.creditLine1 / 100}}</article>
        <article class="right">
          <span class="primary btn cur" @click="toSiteRecord">消费明细</span>
          <span class="primary btn cur" @click="toSiteDetail">账户详情</span>
        </article>
      </section>
      <!-- 可用授信 end -->
      <!-- 自有油站1 -->
      <section class="clearPa" slot="own1">
        <article class="left">
          <span class="error">{{originData.creditLine1 / 100}}</span>
          （可用：
          <span class="error">{{originData.unUsedCreditLine1 / 100}}</span>
          已用：
          <span class="error">{{originData.usedCreditLine1 / 100}}</span>
          ）
        </article>
      </section>
      <!-- 自有油站1 end -->
      <!-- 自有油站2 -->
      <section class="clearPa" slot="own2">
        <article class="left">
          <span class="error">不限额</span>
          （可用：
          <span class="error">不限额</span>
          已用：
          <span class="error">{{originData.usedCreditLine2 / 100}}</span>
          ）
        </article>
      </section>
      <!-- 自有油站2 end -->
    </qx-detail-box>
    <!-- 本车队定点油 end -->
  </qx-card>
</template>

<script>
import {
  oilComponyAccount,
} from 'api/service';
export default {
  data () {
    return {
      originData: {
        zhaoyouCashOilBalance: 0, // 找油账户余额(元)：
        creditLine1: 0, // 可用授信
      },
      findData: {
        label: '找油账户',
        tableData: {
          title: [
            {
              prop: 'zhaoyouCashOilBalance',
              label: '余额',
              span: 1,
              slot: true,
            },
            {
              prop: 'zhaoyouRebateOilBalance1',
              label: '无发票',
              slot: true,
            },
            {
              prop: 'zhaoyouRebateOilBalance2',
              label: '供应商赠送',
              slot: true,
            },
            {
              prop: 'zhaoyouCashOilBalance1',
              label: '有发票',
              slot: true,
            },
            {
              prop: 'zhaoyouCashOilBalance2',
              label: '自己收发票',
              width: '50%',
              slot: true,
            },
          ],
          data: {

          },
          approveData: {},
        },
      },
      siteData: {
        label: '本车队定点油',
        tableData: {
          title: [
            {
              prop: 'creditLine1',
              label: '可用授信（元）',
              span: 1,
              slot: true,
            },
            {
              prop: 'own1',
              label: '自有油站(元)',
              slot: true,
            },
            {
              prop: 'own2',
              label: '自有油站(元)',
              width: '50%',
              slot: true,
            },
          ],
          data: {

          },
          approveData: {},
        },
      },
    };
  },
  computed: {
    totalAmount () {
      return (this.originData.zhaoyouCashOilBalance + this.originData.creditLine1) / 100;
    },
  },
  methods: {
    toRecord () { // 账户流水
      this.jump({
        label: '账户流水',
        url: '/manage/service/oil/company/record',
      });
    },
    toCostApply () { // 充值
      this.jump({
        label: '新增管理费用',
        url: '/manage/cost/manage/edit?payType=4308',
        full: true,
      });
    },
    toDetail () { // 账户详情
      this.jump({
        label: '账户详情',
        url: '/manage/service/oil/company/detail',
      });
    },
    toSiteRecord () { // 定点油消费明细
      this.jump({
        label: '油卡消费',
        url: '/manage/service/oil/consume',
      });
    },
    toSiteDetail () { // 定点油账户详情
      this.jump({
        label: '定点油账户详情',
        url: '/manage/service/oil/company/siteDetail',
      });
    },
  },
  async created () {
    this.originData = await oilComponyAccount();
  },
};
</script>

<style scoped lang="scss">
.title{
  height: 32px;
  padding-top: 8px;
  padding-bottom: 28px;
  border-bottom: 1px solid #e0e0e0;
  .totalAmount{
    font-size: 32px;
  }
}
.btn{
  margin-left: 16px;
}
</style>
